<template>
  <div>
    <v-flex class="hb-flex">
      <div class="primary-section-content">
        <v-row class="mx-4 mb-2 font-regular mt-4 hb-text-night-light">
          Select contacts to remove from the Do Not Rent list.
        </v-row>
        <v-row no-gutters>
          <v-col
            cols="12"
            class="px-4 pt-2"
          >
            <hb-btn
              :disabled="!selectedContacts || selectedContacts.length === 0"
              accordion
              @click="sectionClicked"
              >Remove from Do Not Rent</hb-btn
            >
          </v-col>
        </v-row>
      </div>
    </v-flex>
    <remove-contact-modal
      v-if="dialog"
      :show="dialog"
      :onClose="closeWindow"
      :contactsList="selectedContacts"
      @removeContact="removeSelectedContacts"
      :btnLoader="removeBtnLoader"
    />
    <payments-notification-modal
      v-model="notificationModal"
      :notificationType="notificationModalType"
    />
  </div>
</template>

<script>
import api from "../../../assets/api.js";
import { mapGetters } from "vuex";
import { notificationMixin } from "@/mixins/notificationMixin.js";
import RemoveContactModal from "./RemoveContactModal.vue";
import { EventBus } from "../../../EventBus.js";
import FLAG_CHANGES_OBJECTS from "@/constants/flag_changes_objects.js";
import PaymentsNotificationModal from "../../payments/PaymentsNotificationModal.vue";
export default {
  name: "BulkEditContact",
  data() {
    return {
      dialog: false,
      notificationModal: false,
      notificationModalType: "",
      removeBtnLoader: false,
    };
  },
  props: ["items", "selectedContacts"],
  mixins: [notificationMixin],
  components: {
    RemoveContactModal,
    PaymentsNotificationModal,
  },
  computed: {
    ...mapGetters({
      selectedProperty: "propertiesStore/defaultProperty",
      hasPermission: "authenticationStore/rolePermission",
    }),
  },
  methods: {
    sectionClicked() {
      if (!this.hasPermission("remove_do_not_rent")) {
        this.notificationModalType = "remove_do_not_rent";
        this.notificationModal = true;
        return;
      }
      this.dialog = true;
    },
    closeWindow() {
      this.dialog = false;
    },
    getSuccessMsg(contact_count = 0, type = ''){
      let to_or_from = type === 'removed' ? 'from' : 'to';
      if(contact_count === 0) {
        return `No contact ${type} ${to_or_from} Do Not Rent List.`;
      }
      return `${contact_count} ${this.$options.filters.pluralize('Contact', contact_count)} ${this.$options.filters.pluralize('has', contact_count)} been successfully ${type} ${to_or_from} Do Not Rent List.`;
    },
    async removeSelectedContacts() {
      try {
        this.removeBtnLoader = true;
        const removedContactIds = this.selectedContacts.map((x) => ({
          id: x.tenant_id,
        }));
        const data = {
          flag_value: false,
          is_flag_value_changed: true,
          flag_object_ids: removedContactIds,
          flag_name: FLAG_CHANGES_OBJECTS.CONTACT_FLAGS.DO_NOT_RENT,
          context: 'remove_contact'
        };
        await api.post(
          this,
          api.FLAG_CHANGES_OBJECTS + "flag-type-bulk-update/contact",
          data
        );
        let successMsg = this.getSuccessMsg(removedContactIds.length, 'removed');
        this.showMessageNotification({
          type: "success",
          description: successMsg,
        });
        EventBus.$emit('handle_select_all', false);
        EventBus.$emit("doNotRentReportUpdated");
      } catch (error) {
        this.showMessageNotification({
          description: error,
        });
      } finally {
        this.removeBtnLoader = false;
      }
      this.closeWindow();
    },
  },
};
</script>
